import { render, staticRenderFns } from "./LandingBuildContent.vue?vue&type=template&id=c947e476&scoped=true"
import script from "./LandingBuildContent.vue?vue&type=script&lang=js"
export * from "./LandingBuildContent.vue?vue&type=script&lang=js"
import style0 from "./LandingBuildContent.vue?vue&type=style&index=0&id=c947e476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c947e476",
  null
  
)

export default component.exports